import { useApolloClient } from "@apollo/client/react/hooks"
import { useCallback } from "react"

import { useEvent } from "shared/lib/useEvent"
import { usePrefetch } from "shared/lib/usePrefetch"

import {
  FavoritesDocument,
  FavoritesProjectDocument,
  FavoritesProjectQuery,
  FavoritesQuery
} from "entities/favorites/graphql/queries.generated"

export function useFavoritesPrefetch() {
  const { query } = useApolloClient()

  const fetchFavoritesProject = useEvent(() =>
    query<FavoritesProjectQuery>({ query: FavoritesProjectDocument })
  )

  const fetchFavorites = useEvent(() =>
    query<FavoritesQuery>({ query: FavoritesDocument })
  )

  const handleFetch = useCallback(
    () => Promise.all([fetchFavoritesProject(), fetchFavorites()]),
    [fetchFavoritesProject, fetchFavorites]
  )

  usePrefetch(handleFetch)
}
